import { VerifyEmailAddressMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const verifyEmailAddressHandler =
  graphql.mutation<VerifyEmailAddressMutation>(
    "verifyEmailAddress",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          verifyEmailAddress: {
            result: true,
          },
        },
      });
    }
  );
